<!-- 标签页 -->
<template>
  <div class="nav-bar">
    <p class="title">{{tab_title}}</p>
    <div class="nav-box">
      <div class="nav">
        <div class="nav_item_list" style="left:0px">
          <div
            class="nav_item"
            v-for="(curren_tab,index) in tab_list"
            :key="index"
            @click="getCurrentIndustry($event,index,curren_tab)"
          >{{curren_tab.name}}</div>
        </div>
        <div class="imgright" @click="right_slide"></div>
      </div>
    </div>
    <div class="nav_content">
      <div class="content-list">
        <div
          class="list-item"
          v-for="(content,index) in content_list"
          :key="index"
          @click="goArticle(content)"
        >
          <div class="imgbox">
            <img :src="content.coverImage + resizeParam({ w: 115, h: 83 }, 200)" alt />
          </div>
          <div class="desc">
            <p class="title">{{content.title}}</p>
            <div class="tag_time">
              <div class="tag_list" @click.stop="noon()">
                <div
                 style=" cursor: pointer;"
                  v-for="(tag,idx) in content.tags"
                  :key="idx"
                  @click="emits(tag)"
                >
                  <div class="tag" v-if="tag.visible">{{tag.tagName}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="time">
            <!-- {{content.createTime.slice(0,10)}} -->
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "nav-bar",
  props: ["tab_title", "tab_list",'pageTitle'],
  data() {
    return {
      currnt_tab: "",
      nav_item: [],
      content_list: [],
      i: 0,
      current_page: 0
    };
  },
  mounted() {
    this.Solution();
    console.log(this.pageTitle);
    console.log(this.tab_list);
  },
  methods: {
    Solution() {
      this.$axios
        .get("/newapi/business-service-cms/cms/cms-content/getContentByNode", {
          params: {
            path: this.tab_list[0].path,
            channelId: this.channelId
          }
        })
        .then(res => {
          // console.log(res, "shujushju");
          this.$set(this.tab_list[0], "content_list", res.data.data);
          // 数据初始化
          this.initTab();
        });
      for (var i = 0; i < this.tab_list.length; i++) {
        if (i > 0) {
          this.getApplicationContent(this.tab_list[i]);
        }
      }
    },
    // 循环拿数据
    getApplicationContent(obj) {
      this.$axios
        .get("/newapi/business-service-cms/cms/cms-content/getContentByNode", {
          params: {
            path: obj.path,
            channelId: this.channelId
          }
        })
        .then(res => {
          // console.log(res, "shujushju");
          this.$set(obj, "content_list", res.data.data);
          // ，强制视图更新
          this.$forceUpdate();
        });
    },
    //初始化tab页
    initTab() {
      this.nav_item_list = document.getElementsByClassName("nav_item_list")[0];
      this.nav_item = document.getElementsByClassName("nav_item");
      this.nav_item[0].classList.add("active");
      this.currnt_tab = this.tab_list[0];
      this.content_list = this.tab_list[this.i].content_list;
      let that = this;
      this.current_page = this.i;
      let _content_list = document.getElementsByClassName("nav_content")[0];
      let _startX;
      let _startY;
      let _left = 0;
      _content_list.addEventListener("touchstart", function(e) {
        _startX = e.changedTouches[0].clientX;
        _startY = e.changedTouches[0].clientY;
      });
      _content_list.addEventListener("touchmove", function(e) {
        // e.preventDefault();

        let moveEndX = e.changedTouches[0].clientX;
        let moveEndY = e.changedTouches[0].clientY;
        let X = moveEndX - _startX;
        let Y = moveEndY - _startY;

        if (X > 60 && Math.abs(X) > Math.abs(Y)) {
          //自左向右划
          if (that.i > 0) {
            if (that.i == that.current_page) {
              // console.log(that.nav_item[that.i]);
              // _left -= that.nav_item[that.i].offsetWidth;
              // console.log(_left);
              // if (_left >= 0 && _left <= 200) {
              //     that.nav_item_list.style.left = -_left + "px";
              // }
              that.i--;
            }
          }
        } else if (X < -60 && Math.abs(X) > Math.abs(Y)) {
          //自右向左划
          if (that.i < that.tab_list.length - 1) {
            if (that.i == that.current_page) {
              // _left += that.nav_item[that.i + 1].offsetWidth;
              // if (_left <= 200 && _left >= 0) {
              //     that.nav_item_list.style.left = -_left + "px";
              // }
              // console.log(_left);
              that.i++;
            }
          }
        }
      });
      _content_list.addEventListener("touchend", function(e) {
        that.current_page = that.i;
        for (let i = 0; i < that.nav_item.length; i++) {
          that.nav_item[i].classList.remove("active");
        }
        that.content_list = that.tab_list[that.i].content_list;
        that.nav_item[that.i].classList.add("active");
      });
    },
    //点击获取当前选中项
    getCurrentIndustry(e, index,item) {
      console.log(this.pageTitle);
    this.emit({ type: 'browse', targetId: item.id,viewTitle: this.pageTitle+"/"+item.name })
      this.nav_item_list = document.getElementsByClassName("nav_item_list")[0];
      this.i = index;
      // let _left = 0;
      // for (var j = 0; j <= this.i; j++) {
      //     _left += this.nav_item[j].offsetWidth;
      // }
      // console.log(_left);
      // if (_left <= 200) {
      //     this.nav_item_list.style.left = -_left + "px";
      // }
      this.current_page = this.i;
      this.content_list = this.tab_list[index].content_list;
      this.currnt_tab = this.tab_list[index];
      for (let i = 0; i < this.nav_item.length; i++) {
        this.nav_item[i].classList.remove("active");
      }
      e.target.classList.add("active");
    },
    //进入文章详情页
    goArticle(obj) {
      if (obj.annexFormatObject.type == "video") {
        // console.log(obj);
        this.$router.push({
          path: "/meeting-info1",
          query: { id: obj.id,
          title:this.pageTitle }
        });
      } else {
        this.$router.push({
          path: "/Article",
          query: {
            id: obj.id,
            title:this.pageTitle
          }
        });
      }
      // this.emit({type:"browse",viewTitle: "行业应用/"+obj.title,targetId: obj.id})
    },
    emits(tag){
      console.log("标签",tag);
       this.$router.push({
         path: '/label-list',
         query: { content: tag.tagName,path:'/solution', title:this.pageTitle}
       })
        // this.emit({
        //   type:"browse",
        //   viewTitle:"行业应用/" +tag.tagName,
        //   targetId: tag.id
        // })
    },
    noon() {},
    right_slide() {
      this.nav_item_list = document.getElementsByClassName("nav_item_list");
      this.nav = document.getElementsByClassName("nav");
      console.log(this.nav);
      this.commonM.animation_scroll(this.nav[0], 150, 300);
    }
  }
};
</script>

<style lang='less'>
.nav-bar {
  margin-top: 20px;
  position: relative;
  .title {
    color: #4a4a4a;
    font-family: "PingFangSC-Medium";
    font-size: 17px;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
  }
  .nav-box {
    width: 100%;
    height: 41px;
    border-bottom: 1px solid #f0f0f0;
    position: relative;
    .nav {
      width: 93%;
      height: 42px;
      overflow: auto;
      .nav_item_list {
        width: fit-content;
        height: 100%;
        display: flex;
        justify-content: flex-start;
        .nav_item {
          color: #4a4a4a;
          font-family: "PingFangSC-Medium";
          font-size: 13px;
          font-weight: 400;
          line-height: 17px;
          margin-right: 25px;
          white-space: nowrap;
          display: flex;
          align-items: center;
        }
        .nav_item:last-child {
          margin-right: 0px;
        }
        .active {
          color: #45a6af;
          position: relative;
        }
        .active:after {
          content: "";
          width: 100%;
          height: 2px;
          background: #45a6af;
          position: absolute;
          bottom: 0;
          left: 0;
        }
      }
    }
    .nav::-webkit-scrollbar {
      display: none;
    }
  }
  .nav_content {
    width: 100%;
    min-height: 350px;
    .content-list {
      width: 100%;
      .list-item {
        position: relative;
        width: 100%;
        height: 75px;
        margin-top: 20px;
        padding-bottom: 20px;
        border-bottom: 1px solid #f0f0f0;
        display: flex;
        justify-content: space-between;
        .time {
              color: #9b9b9b;
              font-family: "PingFangSC-Regular";
              font-size: 10px;
              font-weight: 400;
              position: absolute;
              right: 10px;
              bottom: 15px;
            }
        .imgbox {
          width: 105px;
          height: 100%;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .desc {
          width: 228px;
          height: 100%;
          position: relative;
          .title {
            width: 100%;
            color: #4a4a4a;
            font-family: "PingFangSC-Regular";
            font-size: 13px;
            font-weight: 400;
            line-height: 17px;
            word-wrap: break-word;
            word-break: break-all;
          }
          .tag_time {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            .tag_list {
              width: 210px;
              display: flex;
              flex-wrap: wrap;
              .tag {
                max-width: 45px;
                height: 20px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                border-radius: 3px;
                border: solid 1px #f0a700;
                color: #f0a700;
                font-family: "PingFangSC-Regular";
                font-size: 10px;
                font-weight: 400;
                line-height: 20px;
                margin-right: 10px;
                margin-top: 5px;
                padding: 0 5px;
              }
            }

          }
        }
      }
    }
  }
  .imgright {
    width: 15px;
    height: 15px;
    background: url("../../assets/images/row.png");
    background-size: cover;
    position: absolute;
    top: 16px;
    right: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public-components/Nav-bar.vue